<template>
  <div ref="stat" class="work-stat">
    <div class="legend">{{ legend }}</div>
    <div class="number" ref="number" :data-amount="number">{{ numberObj.amount }}</div>
  </div>
</template>

<script>
import { TimelineMax } from "gsap/TweenMax";

export default {
  props: ["legend", "number"],
  data() {
    return {
      tl: null,
      numberObj: {
        amount: 0
      }
    };
  },
  methods: {
    reveal() {
      this.tl.play();
    }
  },
  mounted() {
    this.tl = new TimelineMax({ paused: true });
    this.tl.to(
      this.numberObj,
      1.75,
      {
        amount: this.number,
        roundProps: "amount",
        ease: Linear.easeNone
      },
      "=-0.1"
    );
  }
};
</script>


<style lang="scss" scoped>
.work-stat {
  padding: 0.5rem 0;

  .number {
    font-size: 2.5rem;
    font-weight: 900;
    color: var(--primary-color);

    @media (min-width: 768px) {
      font-size: 3rem;
    }
  }
}
</style>